/* Homepage by FN · Simplified Nutrition
   Tabs, scroll reveals and add-to-cart for fn-* sections. */
(function () {
  if (window.__fnHomeLoaded) return;
  window.__fnHomeLoaded = true;

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  var io = null;
  if (!designMode && !reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('fn-anim');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }
  function initReveal(root) {
    if (!io) return;
    root.querySelectorAll('[data-fn-reveal]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-fn-tabs]').forEach(function (group) {
      if (group.__fnTabs) return;
      group.__fnTabs = true;
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !on;
          if (on && !reduceMotion) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fn-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Add to cart (works with Wonder's cart drawer) ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && drawer.dataset.cartType === 'drawer' && typeof drawer.renderContents === 'function';
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.getAttribute('data-adding') || 'Adding…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          toast(res.description || res.message || 'Sorry, this item could not be added.');
          return;
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'fn-home', productVariantId: id, cartData: res });
        }
        if (useDrawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.classList.remove('wt-cart--empty');
          drawer.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fn-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  function init(root) {
    initTabs(root || document);
    initReveal(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var holder = e.target && e.target.closest && e.target.closest('[data-fn-tab-for]');
    var tabId = holder && holder.getAttribute('data-fn-tab-for');
    var tab = tabId && document.getElementById(tabId);
    if (tab) tab.click();
  });
})();
